import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import {useToolbarStyles, useStyles} from './EmpresaTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';

function EmpresaTable(props) {
  const { empresas, deleteEmpresa, editEmpresa, setEmpresas} = props;


  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [refreshState, setRefreshState] = useState(new Date());
  const [sortSelected, setSortSelected] = useState('0');
  const [sortType] = useState([
    {
      label: 'Razão social',
      value: '0',
      isChecked: false
    },
    {
      label: 'Nome fantasia',
      value: '1',
      isChecked: false
    },
    {
      label: 'CNPJ',
      value: '2',
      isChecked: false
    }
  ]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    function onChangeSortType(event) {
      setSortSelected(event.target.value);
    }

    function onChooseSortMenu() {
      if(sortSelected === '0'){
        empresas.result = empresas.result.sort(function (a, b) {
          if (a.razaoSocial < b.razaoSocial) {
            return 1;
          }
          if (a.razaoSocial > b.razaoSocial) {
            return -1;
          }
          return 0;
        });
        setEmpresas(empresas);
      }
      else if(sortSelected === '1'){
        empresas.result = empresas.result.sort(function (a, b) {
          if (a.nomeFantasia < b.nomeFantasia) {
            return 1;
          }
          if (a.nomeFantasia > b.nomeFantasia) {
            return -1;
          }
          return 0;
        });
        setEmpresas(empresas);
      }
      else{
        empresas.result = empresas.result.sort(function (a, b) {
          if (a.cnpj < b.cnpj) {
            return 1;
          }
          if (a.cnpj > b.cnpj) {
            return -1;
          }
          return 0;
        });
        setEmpresas(empresas);
      }
    }

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          Empresas
        </Typography>

        <Tooltip title="Ordenação">
          <IconButton
            aria-label="filter list"
            onClick={handleClick}
          >
            <FilterListIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <FormControl >
            <RadioGroup value={sortSelected} onChange={onChangeSortType}>
              {sortType.map((sort) => {
                return (
                  <MenuItem
                    onClick={onChooseSortMenu}
                    key={sort.value}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary" />
                      }
                      label= {sort.label}
                      value={sort.value}

                      labelPlacement="end"
                    />
                  </MenuItem>
                );
              })}
            </RadioGroup>
          </FormControl>

        </Menu>
      </Toolbar>
    );
  };

  function onMouseOveRowTable(event, index) {
    empresas.result[index].on_mouse_over = true;
    setRefreshState(new Date());
  }

  function onMouseLeaveRowTable(event, index) {
    empresas.result[index].on_mouse_over = false;
    setRefreshState(new Date());
  }

  return (
    <Paper className={classes.root}>
      <EnhancedTableToolbar numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_razaoSocial'}
                align={'left'}
              >
                {'Razão Social'}
              </TableCell>
              <TableCell
                key={'label_nomeFantasia'}
                align={'left'}
              >
                {'Nome Fantasia'}
              </TableCell>
              <TableCell
                key={'label_cnpj'}
                align={'left'}
              >
                {'CNPJ'}
              </TableCell>
              <TableCell
                key={'label_actions'}
                align={'right'}
                style={{width: '12%'}}
              >
                {''}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {empresas.result.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((empresa, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={empresa.idEmpresa}
                  onMouseOver={event => onMouseOveRowTable(event, index)}
                  onMouseLeave={event => onMouseLeaveRowTable(event, index)}
                >
                  <TableCell
                    align={'left'}
                  >
                    {empresa.razaoSocial}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {empresa.nomeFantasia}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {empresa.cnpj}
                  </TableCell>
                  <TableCell
                    align={'right'}
                    style={{width: '12%'}}

                  >
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={empresa.on_mouse_over ? 'visible' : 'hidden'}
                    >
                      <IconButton
                        aria-label="update"
                        className={classes.margin}
                        onClick={e => editEmpresa(index)}
                      >
                        <EditIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={empresa.on_mouse_over ? 'visible' : 'hidden'}
                    >
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        onClick={e => deleteEmpresa(index)}
                      >
                        <DeleteIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={empresas.result.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default EmpresaTable;
